import type { UserListQuery } from '@ctms/contracts';

export const userQueryKeys = {
  all: ['users'] as const,
  lists: () => [...userQueryKeys.all, 'list'] as const,
  list: (filters: UserListQuery) => [...userQueryKeys.lists(), filters] as const,
  detail: (id: number) => [...userQueryKeys.all, 'detail', id] as const,
};
